module.exports = __webpack_public_path__ + "static/media/completed.7165a461.svg";